let $ = require('jquery');
import bigSlide from 'bigslide';

function navSlide() {
  $('.nav-btn-action').bigSlide({
    menu: ".main-navigation",
    menuWidth: "100%",
    side: "right",
    beforeOpen: function() {
      $('body').addClass('noscroll');
      $('.overflow').fadeIn(150);
    },
    afterClose: function() {
      $('body').removeClass('noscroll');
      setTimeout(function() {
        $('.overflow').fadeOut(150);
      }, 200);
    }
  });
}

export default navSlide;
